if (!customElements.get('gender-buttons')) {
  class GenderButtons extends HTMLElement {
    connectedCallback() {
      const raw = localStorage.getItem(window.genderStorageKey)?.toLowerCase();
      if (raw?.startsWith('men')) {
        this.gender = 'men';
      } else if (raw?.startsWith('women')) {
        this.gender = 'women';
      } else {
        this.gender = 'men';
        localStorage.setItem(window.genderStorageKey, 'men');
      }

      this._onGenderChange = (e) => this.updateButtons(e.detail.gender);
      document.addEventListener('gender:change', this._onGenderChange);

      this.updateButtons(this.gender);
      GenderButtons.applyToPage(this.gender);

      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-gender]');
        if (!btn || (btn.tagName !== 'BUTTON' && !btn.hasAttribute('role'))) return;
        const gender = btn.dataset.gender;
        if (gender !== 'men' && gender !== 'women') return;
        this.gender = gender;
        localStorage.setItem(window.genderStorageKey, gender);
        document.dispatchEvent(new CustomEvent('gender:change', { detail: { gender } }));
        GenderButtons.applyToPage(gender);
        if (this.dataset.scrollToTop === 'true') window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    disconnectedCallback() {
      document.removeEventListener('gender:change', this._onGenderChange);
    }

    updateButtons(gender) {
      this.querySelectorAll('[data-gender]').forEach((b) => {
        if (b.tagName === 'BUTTON' || b.hasAttribute('role')) {
          b.dataset.gender === gender ? b.classList.add('active') : b.classList.remove('active');
        }
      });
    }

    static applyToPage(gender) {
      document.querySelectorAll('.card__media_women:not([data-fixed-gender]), .card__media_men:not([data-fixed-gender])').forEach((media) => {
        if (gender === 'women' && media.classList.contains('card__media_men')) {
          media.classList.remove('card__media_men');
          media.classList.add('card__media_women');
        } else if (gender === 'men' && media.classList.contains('card__media_women')) {
          media.classList.remove('card__media_women');
          media.classList.add('card__media_men');
        }
      });

      const gridGender = gender === 'men' ? 'man' : 'woman';
      document.querySelectorAll('card-grid').forEach((cg) => {
        if (typeof cg.setActiveGrid === 'function') cg.setActiveGrid(gridGender);
      });
    }
  }

  customElements.define('gender-buttons', GenderButtons);
  window.GenderButtons = GenderButtons;
}
